import { FileText } from 'lucide-react'

import { Button } from '@/components/ui/button'

import type { SoftwareAssuranceWorkflowController } from '@/hooks/workflow/useSoftwareAssuranceWorkflow'

interface ReportStepSectionProps {
  workflow: SoftwareAssuranceWorkflowController
}

export function ReportStepSection({ workflow }: ReportStepSectionProps) {
  return (
    <div className="space-y-3">
      <h4 className="text-sm font-semibold">Report Generation</h4>
      <p className="text-sm text-muted-foreground">
        Generate the final mission report artifacts for ATO packages.
      </p>
      {workflow.reportCapabilities && (
        <div className="grid gap-2 rounded-lg border border-border p-3 bg-muted/20 text-xs text-muted-foreground">
          <div>
            PDF:{' '}
            {workflow.reportCapabilities.formats.pdf.available
              ? 'Available'
              : workflow.reportCapabilities.formats.pdf.note || 'Unavailable'}
          </div>
          <div>
            HTML: {workflow.reportCapabilities.formats.html.available ? 'Available' : 'Unavailable'}
          </div>
          <div>
            CSV: {workflow.reportCapabilities.formats.csv.available ? 'Available' : 'Unavailable'}
          </div>
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        <Button
          variant="outline"
          onClick={workflow.handleExportPdf}
          disabled={workflow.reportBusy || workflow.reportCapabilities?.formats.pdf.available === false}
        >
          Export PDF
          <FileText className="ml-2 h-4 w-4" />
        </Button>
        <Button variant="outline" onClick={workflow.handleExportHtml} disabled={workflow.reportBusy}>
          Export HTML
          <FileText className="ml-2 h-4 w-4" />
        </Button>
        <Button variant="outline" onClick={workflow.handleExportCsv} disabled={workflow.reportBusy}>
          Export CSV
          <FileText className="ml-2 h-4 w-4" />
        </Button>
      </div>
      {workflow.reportError && <p className="text-xs text-destructive">{workflow.reportError}</p>}
    </div>
  )
}
